<template>  
    <VuePerfectScrollbar :class="{'my-account-scroll-area-mobile h-full': !isDesktop}" :settings="settings">
      <div class="vx-col md:w-1/1 w-full">
        <vx-card title="" class="card-content">
          <div class="">
            <div class="vx-col sm:w-1/3 w-full">
              <div class="lbl-form">{{ $t("MY_ACCOUNT").Field_Name }}</div>
            </div>
            <div class="vx-col sm:w-3/3 w-full">
              <vs-input class="w-full myacc" v-model="form.name" disabled icon="icon icon-user"
                        icon-pack="feather"/>
            </div>
          </div>
          <div class="">
            <div class="vx-col sm:w-1/3 w-full">
              <div class="lbl-form">{{ $t("MY_ACCOUNT").Field_Email }}</div>
              <!-- <div class="btn-change-account">Validar</div> -->
            </div>
            <div class="vx-col sm:w-3/3 w-full">
              <vs-input class="w-full myacc" v-model="form.email" disabled icon="icon icon-mail"
                        icon-pack="feather"/>
            </div>
          </div>
          
          <div class="">
            <div class="vx-col sm:w-1/3 w-full">
              <div class="lbl-form">{{ $t("MY_ACCOUNT").Field_CnpjCpf }}</div>
            </div>
            <div class="vx-col sm:w-3/3 w-full">
              <vs-input class="w-full myacc" v-model="form.cnpj_cpf" disabled icon="icon icon-user"
                        icon-pack="feather"/>
            </div>
          </div>
          <div class="" v-if="form.phone">
            <div class="vx-col sm:w-1/3 w-full">
              <div class="lbl-form">{{ $t("MY_ACCOUNT").Field_Phone }}</div>
            </div>
            <div class="vx-col sm:w-3/3 w-full">
              <vs-input class="w-full myacc" v-model="form.phone" disabled icon="icon icon-phone"
                      icon-pack="feather"/>
            </div>
          </div>
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{ $t("MY_ACCOUNT").Field_Groups }}</span>
            </div>
            <div class="vx-col sm:w-3/3 w-full" v-if="form.groups">
              <vs-input class="w-full" v-model="form.groups" disabled />
            </div>
          </div> -->
          <div class="">
            <div class="vx-col sm:w-1/3 w-full">
              <div class="lbl-form">{{ $t("MY_ACCOUNT").Field_Country }}</div>
            </div>
            <div class="vx-col sm:w-3/3 w-full">
              <vs-input class="w-full myacc" v-model="form.country.name" disabled icon="icon icon-globe"
                      icon-pack="feather"/>
            </div>
          </div>
          <div>
            <vs-button class="mt-1 ml-1" size="small" type="filled" icon-pack="feather" icon="icon-edit" @click="openAttendanceEditData" > {{ $t('BUTTONS').Edit_Data }} </vs-button>
          </div>
          <div><vs-button color="danger" class="w-full mt-5" @click="onDeleteAccount" aria-disabled="true" type="filled" icon-pack="feather" icon="icon-trash">{{$t('DELETE_ACCOUNT').Delete_Account_Button}}</vs-button></div>
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full" style="display: flex;">
              <span
                >{{ $t("MY_ACCOUNT").Field_Language
                }}<span class="required-field"></span
              ></span>
            </div>
            <div class="vx-col sm:w-3/3 w-full" style="display: grid;">
              <Flags></Flags>
              <div
                style="font-size: 0.8rem; margin-top: 5px; font-style: italic;"
              >
                {{ $t("MY_ACCOUNT").Text_Language }}
              </div>
            </div>
          </div> -->
          <!-- <div id="user-email-config">
            <h5>{{ $t("MY_ACCOUNT").Title_Receive_Email }}</h5>
            <vs-row vs-w="12"> 
              <vs-col
                vs-type="flex"
                vs-lg="6"
                vs-sm="1"
                vs-xs="2"
                class="col-flex-news"
              >
              <div class="vx-col sm:w-1/1 w-full">
                <span>{{ $t("MY_ACCOUNT").Field_Option_All }}</span>            
                </div>
                <div class="vx-col sm:w-1/2 w-full input-switch">
                <vs-switch v-model="selectAll" @change="selectAll = !selectAll" />
                </div>

              </vs-col>
            </vs-row>

            <vs-row vs-w="12">
              <vs-col
                vs-type="flex"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                v-for="(item, index) in content"
                :key="index"
              >
                <div class="vx-col sm:w-1/1 w-full">
                  <span>{{ item.name }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full input-switch">
                  <vs-switch
                    v-model="form.sendmail_content"
                    :vs-value="item.id"
                    @change="onChangeSwitchEmail(item.id)"
                  />
                </div>
              </vs-col>
            </vs-row>
          </div> -->

          <!-- <div class="vx-row mb-6" v-for="(item, index) in content" :key="index">
          <div class="vx-col sm:w-1/3 w-full">
            <span>{{item.nome}}</span>
          </div>
          <div class="vx-col sm:w-3/3 w-full">
            <vs-switch v-model="form.sendmail_content" :vs-value="item.id" @change="onChangeSwitchEmail(item.id)"/>
          </div>
          </div>-->
          <!-- <vs-button color="primary" class="w-full mt-5" @click="onSubmit" aria-disabled="true">{{
              $t("BUTTONS").Save
            }}</vs-button> -->
        </vx-card>
      </div>
      <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
    </VuePerfectScrollbar>
</template>

<script>
import AppConstants from "../../appConstants";
import contentService from "../../providers/contentService";
import userService from "../../providers/userService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { getLocaleCode } from "@/helpers/locale-helper";
import Flags from "../../components/translate/Flags";
import { EventBus } from '../../event-bus';
import { SYSTEM_SERVER_ERROR_CODE } from '../../enums/enum-system-server-error-code';
import messageDialogHelper from '../../helpers/message-dialog-helper';
import authService from '../../providers/authService';

export default {
  components: {
    VuePerfectScrollbar,
    vSelect,
    Flags
  },
  created() {
    EventBus.$emit(AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE, this.$t('MY_ACCOUNT').Title);
    // this.loadData(true);
    this.loadUserData();
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      content: [],
      languages: [],
      country: [],
      allContentSelected: false,
      form: {
        email: "",
        name: "",
        language: 0,
        country: "",
        sendmail_content: [],
        groups: "",
        phone: "",
        cnpj_cpf: "",
      }
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    getTitle() {
      return this.isDesktop ? '' : this.$t('MY_ACCOUNT').Title;
    },
    selectAll: {
      get() {
        return this.allContentSelected;
      },
      set(val) {
        this.allContentSelected = val;
        if (val) {
          this.form.sendmail_content = this.content.map(c => c.id);
        } else {
          this.form.sendmail_content = [];
        }
      }
    }
  },
  watch: {
    "$i18n.locale"(locale) {
      // userService.updateUser(new URLSearchParams(), {language: getLocaleCode(locale)});
      // multi language - when change value request new data from server
      this.form.language = getLocaleCode(locale);
      // this.loadData(false);
      this.loadUserData();
    },
    // "form.sendmail_content"() {
    //   if (this.form.sendmail_content.length == this.content.length) {
    //     this.allContentSelected = true;
    //     return;
    //   }

    //   if (this.form.sendmail_content.length < this.content.length) {
    //     this.allContentSelected = false;
    //   }
    // }
  },
  methods: {
    openAttendanceEditData() {
      messageDialogHelper.displayEditAccountDataMessage(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, this.$t('HELP_ATTENDANCE').Edit_Account_Data);
      });
    },
    onDeleteAccount() {
      messageDialogHelper.displayDialogConfirmCancelWithText(this.$t('DELETE_ACCOUNT').Title,this.$t('DELETE_ACCOUNT').First_Question,this.$t('DELETE_ACCOUNT').First_Question_Button_Decline,this.$t('DELETE_ACCOUNT').First_Question_Button_Continue, (callback) => {
        if (callback == 'cancel') {
          userService.deleteAccount(new URLSearchParams())
          .then(() => {
            messageDialogHelper.displayDialogAccept(this.$t('DELETE_ACCOUNT').First_Question_Success_Title, this.$t('DELETE_ACCOUNT').First_Question_Success_Text, () => {
              authService.logout();
            });
          })
          .catch(err => {
            if (err.code == SYSTEM_SERVER_ERROR_CODE.USER_CANNOT_DELETE.code) {
              messageDialogHelper.displayDialogAccept(this.$t('DELETE_ACCOUNT').Title,this.$t('DELETE_ACCOUNT').Cannot_Delete_Text, () => {});
            }
          });
        } 
      });
    },
    onClose() {
      this.$emit('close');
    },
    getContentName(item) {
      return item[`name${this.$i18n.locale}`];
    },
    loadData(loadUserData) {
      Promise.all([
        contentService.getContentNotification(new URLSearchParams()),
      ]).then(res => {
          this.content = res[0];
          if (loadUserData) {
            this.loadUserData();
          }
          // console.log(this.content);
        })
        .catch(error => console.log(error));
    },
    loadUserData() {
      userService
        .getUserDetails(new URLSearchParams())
        .then(data => {
          // this.languages = data.listLanguage;
          // this.country = data.listCountry;

          this.form.email = data.email;
          this.form.name = data.name;
          // this.form.language = data.language;
          this.form.country = data.country;
          this.form.groups = data.groups;
          this.form.cnpj_cpf = data.cnpj_cpf;
          this.form.phone = data.phone ? data.phone.trim() : '';
          // this.form.sendmail_content =
          //   data.sendmail_content.length > 0
          //     ? data.sendmail_content.map(item => item.id)
          //     : [];
          // console.log("user data ->", data);
        })
        .catch(error => console.log(error));
    },
    onSubmit() {
      // const body = {
      //   sendmail_content: this.form.sendmail_content.map(item => {
      //     return {
      //       _id: item
      //     }
      //   })
      // }
      // userService
      //   .updateUser(new URLSearchParams(), body)
      //   .then(data => {
      //     messagesNotifyHelper.successNotify(
      //       this.$t("MY_ACCOUNT").Notify_Success_Title,
      //       this.$t("MY_ACCOUNT").Notify_Success_Message
      //     );
      //   })
      //   .catch(error => console.log(error));
    },
    onBack() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE);
      this.$router.back();
    },
    onChangeSwitchEmail(value) {
      const index = this.form.sendmail_content.findIndex(i => i == value);
      if (index >= 0) {
        this.form.sendmail_content.splice(index, 1);
      } else {
        this.form.sendmail_content.push(value);
      }
    }
  },
  mounted() {
    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK, () => {
      this.onBack();
    });
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK);
  }
};
</script>

<style lang="scss">
#user-email-config {
  h5 {
    margin-bottom: 10px;
  }
  .vs-col {
    margin-top: 6px;
  }
  .input-switch {
    align-self: center;
  }
}

.row-btn {
  margin: 10px 0px;
}
.custom-scroll-content-my-account {
  height: calc(100% - 100px);
}
.my-account-help-language {
  margin-left: 10px;
}
.required-field {
  margin-left: 2px;
  color: red;
}

.theme-dark {
  .vs__clear {
    background-color: #363c42 !important;
  }
  .vs__open-indicator {
    background-color: #363c42 !important;
  }
}
#my-account-scroll {
  #flags {
    float: left;
  }
}
</style>
